"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isSupported = void 0;

var _detectrtc = _interopRequireDefault(require("detectrtc"));

var _loglevel = _interopRequireDefault(require("loglevel"));

/* eslint-disable no-continue */
var MODULE_NAME = 'sdk/browser/utils/support';

var logger = _loglevel.default.getLogger(MODULE_NAME);
/**
 *
 * @param {[{
 *      name: string,
 *      lowestVersion: number|string,
 *      excludedVersions: [],
 *      lowestRenderVersion: number|string
 * }]} supportedBrowsers
 * @returns {boolean}
 */


var isSupported = function isSupported(supportedBrowsers) {
  logger.info("".concat(MODULE_NAME, " - isSupported called"), _detectrtc.default.browser, supportedBrowsers);

  if (!supportedBrowsers || !Array.isArray(supportedBrowsers)) {
    console.error("".concat(MODULE_NAME, " - isSupported missing supportedBrowsers"));
    return false;
  }

  for (var i = 0; i < supportedBrowsers.length; i += 1) {
    if (supportedBrowsers[i].name === _detectrtc.default.browser.name) {
      if (_detectrtc.default.browser.version < supportedBrowsers[i].lowestVersion) {
        continue;
      }

      for (var idx = 0; idx < supportedBrowsers[i].excludedVersions.length; idx += 1) {
        if (_detectrtc.default.browser.version === supportedBrowsers[i].excludedVersions[idx]) {
          continue;
        }
      }

      if (_detectrtc.default.isWebRTCSupported && _detectrtc.default.isGetUserMediaSupported) {
        logger.debug("".concat(MODULE_NAME, " - isSupported res"), true);
        return true;
      }
    }
  }

  logger.debug("".concat(MODULE_NAME, " - isSupported res"), false);
  return false;
};

exports.isSupported = isSupported;